import React from "react";
import styled from "styled-components";
import CheckMark from "src/img/check@2x.png";
import { portalColors } from "./BusinessPortalComponents";

const OuterButton = styled.button`
    position: relative;
    min-width: ${p => p.minWidth || "12rem"};
    min-height: 42px;
    height: ${p => p.height || "42px"};
    padding: 0 2.5rem 0 1rem;
    cursor: pointer;
    border: 1px solid ${p => p.active ? portalColors.text : portalColors.borderStrong};
    border-radius: 8px;
    text-align: left;
    font-size: 0.875rem;
    font-family: Manrope, Helvetica, sans-serif;
    color: ${portalColors.text};
    background-color: ${p => p.active ? portalColors.blueSoft : portalColors.surfaceSoft};
    font-weight: ${p => p.active ? 700 : 400};
    box-shadow: ${p => p.active ? `inset 0 0 0 1px ${portalColors.text}` : "none"};

    &:focus-visible {
        outline: 2px solid ${portalColors.text};
        outline-offset: 2px;
    }
`;

function RadioButton({ children, active, onClick }) {
    return (
        <OuterButton active={active} onClick={onClick}>
            {children}
            { active &&
                <img src={CheckMark} alt="check mark" style={{ height: "22px", position: "absolute", top: "9px", right: "8px" }} />
            }
        </OuterButton>
    );
}

export default RadioButton;
